var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoVde(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 179 86",
    style: {
      enableBackground: "new 0 0 179 86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000059271007712378198130000009654371778805320632_);}\n\t.st2{fill:#929497;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.274,
    y1: 87.1964,
    x2: 16.3038,
    y2: 37.1008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#26A9E0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.9,58.8c0,14.3,11.6,25.9,25.9,25.9c2.4,0,4.8-0.3,7.1-1l-0.1,0c-0.5,0-1.1,0-1.6,0l-0.4,0 c-0.2,0-0.5,0-0.7-0.1l-0.4-0.1c-0.2,0-0.4,0-0.6-0.1l-1-0.2c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.3-0.1-0.5-0.1 c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0-0.3-0.1-0.5-0.1c-0.2-0.1-0.4-0.1-0.6-0.2L26,82.5c-0.2-0.1-0.4-0.1-0.6-0.2l-0.3-0.1 c-0.2-0.1-0.4-0.2-0.7-0.3l-0.2-0.1c-4.3-1.9-7.9-5.2-10.2-9.3c-1.9-3-2.9-6.6-3.1-10.2c0-0.3,0-0.5,0-0.8c0-0.7,0-1.4,0.1-2.1 c0-0.1,0-0.2,0-0.3l0-0.2c0.1-0.5,0.1-1,0.2-1.5c0-0.2,0.1-0.4,0.1-0.6l0.1-0.2c0.1-0.4,0.2-0.7,0.3-1c0.1-0.3,0.2-0.7,0.3-1 l0.3-0.9l0,0l0.3-0.7l20.1-39.9L26.8,1l0,0l0,0l-6.1,12.1l-0.1,0.3L3,48.2l-0.4,0.9c-0.4,1.2-0.8,2.3-1.1,3.5 c-0.4,1.9-0.7,3.9-0.7,5.8V58.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049918206811801368560000000286787909289328513_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.4765,
    y1: 54.3297,
    x2: 54.0225,
    y2: 54.3297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6921E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5048,
    style: {
      stopColor: "#FFCA05"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049918206811801368560000000286787909289328513_)"
    },
    d: "M54,58l0-0.6c-0.1-1.6-0.3-3.2-0.6-4.8 c-0.3-1.1-0.6-2.3-1.1-3.5l-0.4-0.9l-11.4-21l-6,12l1.5,2.7l6,10.8c0.1,0.3,0.2,0.5,0.3,0.7c0,0.1,0.1,0.3,0.1,0.4 c0.1,0.2,0.1,0.4,0.2,0.6c0.4,1.3,0.6,2.7,0.6,4.1c0,8.3-6.8,15.1-15.1,15.1H28c-2,0-3.9-0.4-5.7-1.1c-4.4-1.8-7.6-5.5-8.8-9.9 c0.1,1.6,0.3,3.1,0.8,4.6c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.4,0.3,0.7,0.4,1.1c0.2,0.4,0.4,0.9,0.6,1.3c0,0.1,0.1,0.1,0.1,0.2 c2,4.1,5.5,7.5,9.7,9.4v0c0.1,0,0.1,0.1,0.2,0.1l0,0c0.2,0.1,0.4,0.2,0.6,0.2l0.2,0.1c0.1,0,0.2,0.1,0.3,0.1 c0.1,0,0.2,0.1,0.3,0.1l1.3,0.4c0.2,0,0.3,0.1,0.5,0.1l0.9,0.2c0.2,0,0.3,0.1,0.5,0.1l0,0c0.2,0,0.4,0.1,0.6,0.1 c0.1,0,0.2,0,0.3,0l0.4,0c0.2,0,0.4,0,0.5,0c0.4,0,0.7,0.1,1.1,0.1c0.2,0,0.4,0,0.6,0l0.3,0c0.5,0,1,0,1.4-0.1 c0.4,0,0.8-0.1,1.2-0.2l0.4-0.1c0.1,0,0.3,0,0.4-0.1c0.5-0.1,0.9-0.2,1.4-0.4l0.2-0.1c0.1,0,0.2-0.1,0.3-0.1 c0.5-0.2,1-0.3,1.4-0.5l0.4-0.2c0.5-0.2,1-0.4,1.4-0.7l0.3-0.2c0.5-0.3,1-0.6,1.4-0.9l0.2-0.1c0.5-0.3,1-0.7,1.4-1.1 c0.9-0.8,1.8-1.6,2.6-2.6l0.1-0.2c0.4-0.6,0.8-1.1,1.2-1.7c0.1-0.2,0.2-0.4,0.4-0.6l0.3-0.5c0.1-0.1,0.2-0.3,0.2-0.4l0.1-0.3 c0.3-0.5,0.5-1,0.7-1.5l0.1-0.2c0-0.1,0-0.1,0.1-0.2c0.5-1.2,0.9-2.2,1.2-3.2c0.2-0.7,0.3-1.3,0.5-1.9c0.1-0.3,0.1-0.6,0.2-0.9 c0.1-0.3,0.1-0.6,0.1-0.9l0-0.2c0.1-0.5,0.1-0.9,0.2-1.3c0-0.1,0-0.2,0-0.3l0-0.6c0-0.3,0-0.6,0-1C54,58.4,54,58.2,54,58z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.5,21.1h7.2L99.3,63.9H85.7L75.2,21.1h7.2l8.5,36.6H94L102.5,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.1,63.9h-14.8V21.1h14.8c6.6,0,11.1,1.7,13.5,5c2.4,3.3,3.6,8.5,3.6,15.7c0,3.6-0.2,6.7-0.7,9.2 c-0.5,2.5-1.3,4.8-2.5,6.8C140.6,61.8,136,63.9,129.1,63.9z M139.1,41.8c0-5.2-0.6-8.9-1.9-11.2s-4-3.4-8-3.4h-7.9v30.6h7.9 c4.1,0,6.9-1.5,8.2-4.6c0.7-1.5,1.1-3.2,1.3-4.9C139,46.5,139.1,44.3,139.1,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151,63.9V21.1h27v6.1h-20v12.1h20v6h-20v12.5h20v6.1H151z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVde);
export default __webpack_public_path__ + "static/media/logoVDE.2f633e9820da12e24a417bb648d7b7ac.svg";
export { ForwardRef as ReactComponent };